<div class="container-fluid">
  <div class="m-2">
    <div class="card mx-2">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h4 class="mb-0">Education Presentation List</h4>
        <button mat-raised-button color="primary" (click)="createNew()"
                permission="Education Presentation"
                [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]">
          <mat-icon>add</mat-icon>
          Create New Presentation
        </button>
      </div>
      <div class="card-body">

        <!-- Advanced Filters -->
        <div class="row mb-3">
          <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Filter Start Date</mat-label>
              <input matInput [matDatepicker]="filterStartPicker" [(ngModel)]="filterStartDate" placeholder="Start Date">
              <mat-datepicker-toggle matSuffix [for]="filterStartPicker"></mat-datepicker-toggle>
              <mat-datepicker #filterStartPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Filter End Date</mat-label>
              <input matInput [matDatepicker]="filterEndPicker" [(ngModel)]="filterEndDate" placeholder="End Date">
              <mat-datepicker-toggle matSuffix [for]="filterEndPicker"></mat-datepicker-toggle>
              <mat-datepicker #filterEndPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Filter by Centre</mat-label>
              <mat-select [(ngModel)]="filterCentre">
                <mat-option value="">All Centres</mat-option>
                <mat-option *ngFor="let centre of (centres$ | async)" [value]="centre.centreName">
                  {{ centre.centreName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-3 d-flex align-items-center gap-2">
            <button mat-raised-button color="primary" (click)="applyAdvancedFilter()">
              <mat-icon>filter_alt</mat-icon>
              Apply Filters
            </button>
            <button mat-raised-button (click)="clearFilters()">
              <mat-icon>clear</mat-icon>
              Clear
            </button>
          </div>
        </div>

        <!-- Search Bar -->
        <div class="row mb-3">
          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Search Presentations</mat-label>
              <input matInput (keyup)="applyFilter($event)" placeholder="Search by centre, creator..." #input>
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>
        </div>

        <!-- Table -->
        <div class="table-responsive">
          <table mat-table [dataSource]="dataSource" matSort class="w-100">

            <!-- No Column -->
            <ng-container matColumnDef="no">
              <th mat-header-cell *matHeaderCellDef>Sr.No.</th>
              <td mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</td>
            </ng-container>

            <!-- Centre Name Column -->
            <ng-container matColumnDef="centreName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Centre</th>
              <td mat-cell *matCellDef="let row">
                <strong>{{ row.centreName }}</strong>
              </td>
            </ng-container>

            <!-- Date Range Column -->
            <ng-container matColumnDef="dateRange">
              <th mat-header-cell *matHeaderCellDef>Date Range</th>
              <td mat-cell *matCellDef="let row">
                {{ formatDateRange(row.startDate, row.endDate) }}
              </td>
            </ng-container>

            <!-- Created By Column -->
            <ng-container matColumnDef="createdBy">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
              <td mat-cell *matCellDef="let row">{{ row.createdBy }}</td>
            </ng-container>

            <!-- Created At Column -->
            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Created At</th>
              <td mat-cell *matCellDef="let row">
                {{ formatDate(row.createdAt) }}
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button color="primary"
                        (click)="viewPresentation(row)"
                        matTooltip="View Presentation"
                        permission="Education Presentation"
                        [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button mat-icon-button color="accent"
                        (click)="editPresentation(row)"
                        matTooltip="Edit Presentation"
                        permission="Education Presentation"
                        [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="primary"
                        (click)="duplicatePresentation(row)"
                        matTooltip="Duplicate Presentation"
                        permission="Education Presentation"
                        [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]">
                  <mat-icon>content_copy</mat-icon>
                </button>
                <button mat-icon-button
                        (click)="exportToExcel(row)"
                        matTooltip="Export to Excel"
                        permission="Education Presentation"
                        [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
                  <mat-icon>download</mat-icon>
                </button>
                <button mat-icon-button color="warn"
                        (click)="deletePresentation(row)"
                        matTooltip="Delete Presentation"
                        permission="Education Presentation"
                        [permissionTypes]="[PermissionType.ALL, PermissionType.ARCHIVE]">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>

            <!-- No Data Row -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell text-center" colspan="6">
                <div class="no-data-message">
                  <mat-icon class="large-icon">inbox</mat-icon>
                  <p>No presentations found</p>
                  <button mat-raised-button color="primary" (click)="createNew()">
                    Create Your First Presentation
                  </button>
                </div>
              </td>
            </tr>
          </table>
        </div>

        <!-- Paginator -->
        <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"
                       showFirstLastButtons
                       aria-label="Select page of presentations">
        </mat-paginator>

      </div>
    </div>
  </div>
</div>

